import React, { useState } from 'react';

import Box from '@mui/material/Box';

import KnowledgeLibrary from '../../../../components/KnowledgeLibrary';
import {
  StyledSideTab,
  StyledSideTabs,
} from '../../../../components/StyledTabs';
import Transcript from '../../../../components/Transcript';
import { useViewsStyles } from '../styles';

const KnowledgeBase = () => {
  const styles = useViewsStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <StyledSideTabs value={value} onChange={handleChange}>
        <StyledSideTab
          style={{ borderBottom: 'transparent' }}
          value={0}
          label={'Knowledge Base'}
        />
        <StyledSideTab
          style={{ borderBottom: 'transparent' }}
          value={1}
          label={'Transcript'}
        />
      </StyledSideTabs>

      {value === 0 && (
        <Box sx={styles.copilotPanel}>
          <KnowledgeLibrary />
        </Box>
      )}
      {value === 1 && <Transcript useTabs={false} viewTitle={'Transcript'} />}
    </>
  );
};

export default KnowledgeBase;
